export interface PlantillaTranslations {
  TABLE: {
      NAME: string;
      ACTIONS: string;
      BUTTON: string;
      PLANTILLAS: string;
  };
  // Aquí puedes añadir más secciones de traducción según lo necesites

  // Esta línea es la clave para que el objeto sea indexable por TypeScript
  [key: string]: any;  // Usamos 'any' para simplificar, pero podrías ser más específico si quieres
}

export const plantillaTranslations: { [language: string]: PlantillaTranslations } = {
    en: {
        TABLE: {
            NAME: "Name",
            ACTIONS: "Actions",
            BUTTON: "New Template",
            PLANTILLAS: "Templates"
        },
    },
    es: {
        TABLE: {
            NAME: "Nombre",
            ACTIONS: "Acciones",
            BUTTON: "Nueva Plantilla",
            PLANTILLAS: "Plantillas"
        },
    }
};

